import { render } from "./ProjectCardEmbeddedImage.vue?vue&type=template&id=88082d8c&scoped=true"
import script from "./ProjectCardEmbeddedImage.vue?vue&type=script&lang=js"
export * from "./ProjectCardEmbeddedImage.vue?vue&type=script&lang=js"

import "./ProjectCardEmbeddedImage.vue?vue&type=style&index=0&id=88082d8c&lang=scss"
import "./ProjectCardEmbeddedImage.vue?vue&type=style&index=1&id=88082d8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88082d8c"]])

export default __exports__